import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import { appInfo } from './app-info';
import { appRoutes } from './app-routes';
import { SideNavOuterToolbar as SideNavBarLayout } from './layouts';
import { getApiToken } from './utils/authUtils.js';
import { getPermissions } from './utils/authUtils.js';
import { useUser } from './contexts/user';
import appUpdateService from './services/AppUpdateService';

export const Content = () => {
  const { instance, accounts } = useMsal();
  const { updateUserInfo } = useUser();

  useEffect(() => {
    // Load permissions when content is mounted (user is authenticated)
    getPermissions(instance, accounts, updateUserInfo).catch(error => {
      console.error('Failed to load permissions:', error);
    });

    // Initialize app update service
    appUpdateService.initialize().catch(error => {
      console.error('Failed to initialize app update service:', error);
    });
  }, [instance, accounts, updateUserInfo]); // Dependencies to ensure it runs when authentication state changes

  return (
    <SideNavBarLayout title={appInfo.title}>
      <Routes>
        {appRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route path='*' element={<Navigate to='/home' />} />
      </Routes>
    </SideNavBarLayout>
  );
};
